import { render, staticRenderFns } from "./VenteId.vue?vue&type=template&id=04f1f660"
import script from "./VenteId.vue?vue&type=script&lang=js"
export * from "./VenteId.vue?vue&type=script&lang=js"
import style0 from "./VenteId.vue?vue&type=style&index=0&id=04f1f660&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports